import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkAuthorization, logOutUser } from './store/slices/authSlice';

const useTokenCheck = () => {
  const dispatch = useDispatch();
  const { token, userInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    const validateToken = async () => {
      try {
        await dispatch(checkAuthorization()).unwrap();
      } catch (error) {
        console.error("Token validation failed:", error);
        dispatch(logOutUser({ user: userInfo?._id, token }));
      }
    };

    if (token) {
      const interval = setInterval(() => {
        validateToken();
      }, 8 * 60 * 60 * 1000);
      return () => clearInterval(interval);
    }
  }, [dispatch, token, userInfo?._id]);
};

export default useTokenCheck;